var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
//import { Timeout, Timeouts } from './framework/Timeouts';
export class ToaAmCf1 {
    // private readonly timeouts: Timeouts = new Timeouts();
    // private readonly busyTimeout: Timeout = this.timeouts.create();
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'authFailed',
                send: (cred) => {
                    var _a, _b;
                    const username = ((_a = cred.username) !== null && _a !== void 0 ? _a : 'admin').padEnd(16, String.fromCharCode(0));
                    const password = ((_b = cred.password) !== null && _b !== void 0 ? _b : 'admin').padEnd(16, String.fromCharCode(0));
                    return `\x80\x20${username}${password}`;
                },
                fail: /\x80\x01\x00/,
                next: /\x80\x01\x01/,
            },
        ];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.mute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(
                // mic in channel mute
                `\xF0\x03\x18\x00\x00`, /\x98\x03\x00\x00([\s\S])/, tags);
                return match[1].charCodeAt(0) === 1;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x98\x03\x00\x00${mute ? '\x01' : '\x00'}`, /\x98\x03\x00\x00([\s\S])/, tags);
                return match[1].charCodeAt(0) === 1;
            }),
            // powerOffRestrictions: ['set'],
        };
        // public readonly power: Control<boolean> = {
        //     get: async (tags: Array<string>): Promise<boolean> => {
        //         const match = await this.socket.send(`\xF0\x02\x72\x00`, /\xF3\x02\x00([\s\S])/, tags);
        //         // Power true means standby is false.
        //         return match[1].charCodeAt(0) === 0;
        //     },
        //     set: async (power: boolean, tags: Array<string>): Promise<boolean> => {
        //         const match = await this.socket.send(
        //             `\xF3\x02\x00${power ? '\x00' : '\x01'}`,
        //             /\xF3\x02\x00([\s\S])/,
        //             tags
        //         );
        //         this.state.busy.update(true);
        //         this.busyTimeout.set(() => this.state.busy.update(false), 1000);
        //         return match[1].charCodeAt(0) === 0;
        //     },
        // };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\xF0\x03\x11\x01\x00`, /\x91\x03\x01\x00([\s\S])/, tags);
                return match[1].charCodeAt(0);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand([0x91, 0x03, 0x01, 0x00, volume]), /\x91\x03\x01\x00([\s\S])/, tags);
                return match[1].charCodeAt(0);
            }),
            range: { max: 0x3d, min: 0, round: 1 },
            // powerOffRestrictions: ['set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(
                // speaker out channel mute
                `\xF0\x03\x18\x01\x00`, /\x98\x03\x01\x00([\s\S])/, tags);
                return match[1].charCodeAt(0) === 1;
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x98\x03\x01\x00${mute ? '\x01' : '\x00'}`, /\x98\x03\x01\x00([\s\S])/, tags);
                return match[1].charCodeAt(0) === 1;
            }),
            // powerOffRestrictions: ['set'],
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['volume', 'volumeMute', 'mute'] },
        ];
    }
    // phase callbacks
    // public async onConfigure(): Promise<void> {
    //     this.timeouts.clearAll();
    // }
    // public async onDisconnect(): Promise<void> {
    //     this.timeouts.clearAll();
    // }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    makeCommand(data) {
        return AsciiText.decode(data);
    }
}
// static properties
ToaAmCf1.driverType = 'socketDriver';
ToaAmCf1.key = '-MZNXUJUJvvHoVzNxpTf';
ToaAmCf1.baseSocketOptions = {
    commandExtractor: (buffer) => {
        let cmdLength = 0;
        for (let i = 0; i < buffer.length - 1; i++) {
            if (buffer.charCodeAt(i) >= 0x80) {
                // Commands are 0x80 to 0xFF.
                cmdLength = buffer.charCodeAt(i + 1);
                if (cmdLength > buffer.length - 2)
                    break;
                const command = buffer.slice(i, i + cmdLength + 2);
                buffer = buffer.slice(i + cmdLength + 2);
                return { command, buffer };
            }
        }
        return undefined;
    },
    sendTerminator: '',
    isBinary: true,
};
ToaAmCf1.socketOptions = [
    Object.assign(Object.assign({}, ToaAmCf1.baseSocketOptions), { port: 3000 }),
];
